import React from 'react';

// User-approved excerpts; source screenshots and wording revisions: memory/TRIAL_AGENCY_REFRESH.md.
const quotes = [
  { id: 'stephen', name: 'Stephen Petrucci', text: 'Three deals closed in the past month since running Voxinity inside my AI consultancy.\n£12,500 in 30 days, and the part that still gets me is how fast it all moved.' },
  { id: 'sarah', name: 'Sarah McLeod', text: "I've just jumped in scraped a couple of hundred leads and sent proposals... the ability to attach the orb/ chat widget embed code and calendar link all within the proposal is pure 🔥🔥🔥🔥🔥🔥" },
];

export const TrialTestimonials = () => (
  <section className="trial-testimonials" aria-label="From the Voxinity community" data-testid="trial-testimonials">
    {quotes.map(quote => <figure key={quote.id} className="trial-quote" data-testid={`trial-testimonial-${quote.id}`}>
      <blockquote data-testid={`trial-testimonial-${quote.id}-quote`}>“{quote.text}”</blockquote>
      <figcaption data-testid={`trial-testimonial-${quote.id}-author`}>{quote.name}</figcaption>
    </figure>)}
    <p className="trial-testimonial-note" data-testid="trial-testimonial-results-note">Individual results vary.</p>
  </section>
);